import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

import './index.css';
import App from './App';
import unregisterServiceWorker from './unregisterServiceWorker';
import reducer from './store/reducer';

const store = createStore(reducer);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// Actively unregister any existing service workers
// This ensures users who had the old service worker get it removed
// and start receiving fresh content immediately after deployments
unregisterServiceWorker();





// WEBPACK FOOTER //
// ./src/index.js